var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GenericProvider } from '../genericprovider.provider';
import { HttpClient } from '@angular/common/http';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';
import { Session } from '../../../model/session.model';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "angular2-flash-messages/module/flash-messages.service";
import * as i3 from "@angular/router";
var SessionService = /** @class */ (function (_super) {
    __extends(SessionService, _super);
    function SessionService(http, _flashMessagesService, router) {
        var _this = _super.call(this, _flashMessagesService) || this;
        _this.http = http;
        _this._flashMessagesService = _flashMessagesService;
        _this.router = router;
        return _this;
    }
    SessionService.prototype.getSessionsHistory = function () {
        return this.http.get(this.api_url + '/consultations/previous').pipe(catchError(this.handleError('SessionService : getSessionsHistory()', [])));
    };
    SessionService.prototype.getNextSessions = function () {
        return this.http.get(this.api_url + '/consultations/coming-up').pipe(catchError(this.handleError('SessionService : getNextSessions()', [])));
    };
    SessionService.prototype.updateSessionStatus = function (id, status) {
        return this.http.put(this.api_url + '', status).pipe(catchError(this.handleError('SessionService : updateSessionStatus(' + id + ',' + status + ')', new Session())));
    };
    SessionService.ngInjectableDef = i0.defineInjectable({ factory: function SessionService_Factory() { return new SessionService(i0.inject(i1.HttpClient), i0.inject(i2.FlashMessagesService), i0.inject(i3.Router)); }, token: SessionService, providedIn: "root" });
    return SessionService;
}(GenericProvider));
export { SessionService };
